import { useMutation } from '@tanstack/react-query'
import { putEditMerchant } from 'services/MerchantService'

export const usePutEditMerchantMutation = () => {
  return useMutation({ mutationFn: putEditMerchant })
}
